import {
	RECORD_ADDRESS,
	ADD_CART,
	REDUCE_CART,
	INIT_BUYCART,
	CLEAR_CART,
	RECORD_SHOPDETAIL,
	RECORD_USERINFO,
	GET_USERINFO,
	CONFIRM_REMARK,
	CONFIRM_INVOICE,
	CHOOSE_SEARCH_ADDRESS,
	SAVE_GEOHASH,
	CONFIRM_ADDRESS,
	CHOOSE_ADDRESS,
	NEED_VALIDATION,
	SAVE_CART_ID_SIG,
	SAVE_ORDER_PARAM,
	CHANGE_ORDER_PARAM,
	ORDER_SUCCESS,
	SAVE_SHOPID,
	SAVE_ORDER,
	OUT_LOGIN,
	RETSET_NAME,
	SAVE_AVANDER,
	SAVE_ADDRESS,
	SAVE_ADDDETAIL,
	SAVE_QUESTION,
	ADD_ADDRESS,
	BUY_CART,
	ACT_PROGRESS,
	URL_PARAMS,
	GET_TICKET,
	GET_DEVICEINFO,
	GET_VOUCHER,
	GET_PRODUCT,
	GET_GOSTYLE,
	GET_BGIMAGE,
	GET_GIFT,
	GET_OPENID,
	GET_ORDERLIST,
} from './mutation-types.js'

import {setStore, getStore} from '../api/mUtils'
import { ACT_ORDER, ACT_GO, ACT_P_ORDER, ACT_E_GO } from '../constant/act_stat.js';
import { OrderProduct,GoProduct, giftQuantity } from '../constant/products.js';
import { TICKET, WX_OPEN_ID } from '../constant/CookieKeys.js';
import * as Cookie from 'tiny-cookie'
// import {localapi, proapi} from 'src/config/env'

export default {
	// 记录当前经度纬度
	[RECORD_ADDRESS](state, {
		latitude,
		longitude
	}) {
		state.latitude = latitude;
		state.longitude = longitude;
	},

	[RECORD_SHOPDETAIL](state, detail) {
		state.shopDetail = detail;
	},
	// 加入购物车
	[ADD_CART](state, {
		shopid,
		category_id,
		item_id,
		food_id,
		name,
		price,
		specs,
		packing_fee,
		sku_id,
		stock
	}) {
		let cart = state.cartList;
		let shop = cart[shopid] = (cart[shopid] || {});
		let category = shop[category_id] = (shop[category_id] || {});
		let item = category[item_id] = (category[item_id] || {});
		if (item[food_id]) {
			item[food_id]['num']++;
		} else {
			item[food_id] = {
					"num" : 1,
					"id" : food_id,
					"name" : name,
					"price" : price,
					"specs" : specs,
					"packing_fee" : packing_fee,
					"sku_id" : sku_id,
					"stock" : stock
			};
		}
		state.cartList = {...cart};
		//存入localStorage
		setStore('buyCart', state.cartList);
	},
	// 移出购物车
	[REDUCE_CART](state, {
		shopid,
		category_id,
		item_id,
		food_id,
		name,
		price,
		specs,
	}) {
		let cart = state.cartList;
		let shop = (cart[shopid] || {});
		let category = (shop[category_id] || {});
		let item = (category[item_id] || {});
		if (item && item[food_id]) {
			if (item[food_id]['num'] > 0) {
				item[food_id]['num']--;
				state.cartList = {...cart};
				//存入localStorage
				setStore('buyCart', state.cartList);
			} else {
				//商品数量为0，则清空当前商品的信息
				item[food_id] = null;
			}
		}
	},
	//网页初始化时从本地缓存获取购物车数据
	[INIT_BUYCART](state) {
		let initCart = getStore('buyCart');
		if (initCart) {
			state.cartList = JSON.parse(initCart);
		}
	},
	//清空当前商品的购物车信息
	[CLEAR_CART](state, shopid) {
		state.cartList[shopid] = null;
		state.cartList = {...state.cartList};
		setStore('buyCart', state.cartList);
	},
	// 记录用户信息
	[RECORD_USERINFO](state, info) {
		state.userInfo = info;
		state.islogin = true;
		console.log("RECORD_USERINFO:userInfo",state.userInfo)
		console.log("RECORD_USERINFO:islogin",state.islogin)
		setStore(TICKET, info.ticket);
	},
	// 获取ticket
	[GET_TICKET](state,ticket) {
		state.ticket = ticket;
	},	
	// 获取ticket
	[GET_DEVICEINFO](state,device_info) {
		state.deviceInfo = device_info;
	},		
	//获取用户信息存入vuex
	[GET_USERINFO](state, info) {
		if (state.userInfo && (state.userInfo.username !== info.username)) {
			return;
		};
		if (!state.login) {
			return
		}
		if (!info.message) {
			state.userInfo = {...info};
		} else {
			state.userInfo = null;
		}
	},
	//获取活动信息存入vuex
	[ACT_PROGRESS](state, info) {	
		console.log("ACT_PROGRESS",info)	
		if (info) {
			state.actInfo = {...info};
		} else {
			state.actInfo = null;
		}
	},
	//获取活动信息存入vuex
	[GET_PRODUCT](state, info) {	
		console.log("GET_PRODUCT")	
		if(state.actInfo.progress==ACT_ORDER){
			state.product = OrderProduct
		}
		else if(state.actInfo.progress==ACT_GO){
			state.product = GoProduct
		}
		
	},	
	//获取参数信息存入vuex
	[URL_PARAMS](state, info) {	
		console.log("URL_PARAMS",info)	
		if (info) {
			state.urlParams = {...info};
		} else {
			state.urlParams = null;
		}
	},	
	[GET_VOUCHER](state, info){
		if (info) {
			console.log("GET_VOUCHER",info)	
			state.voucher = {...info};
		}
	},
	[GET_GOSTYLE](state, info){
		if (info.id) {
			console.log("GET_VOUCHER",info)	
			state.goStyle = "YUYUE";
		}
	},	
	[GET_GIFT](state, res){
		if (res && res.err == 0) {
			state.progress = giftQuantity -res.data;
			if(res.data>0)
			  state.progressShow = "progressShow"
		}
	},		
	[GET_ORDERLIST](state, res){
		if (res) {
			console.log("GET_ORDERLIST",res)
			if (res && res.err == 0) {	
				state.orderList = {...res.data};
			}
		}
	},
	[GET_OPENID](state, res){
		console.log("GET_OPENID",res)	
		if (res && res.err == 0) {
			var udata = typeof res.data == "string" ? JSON.parse(res.data) : res.data;
			if (udata.openid) {
				openId_pay = udata.openid;
				Cookie.set(WX_OPEN_ID, openId_pay, {expires: '3h'})
				// setStore(OPENID,openId_pay)
			}
			else{
				console.log("获取openId失败")
			}
		}
		else
			console.log("获取openId失败")
	},			
	[GET_BGIMAGE](state, info){
		console.log("GET_BGIMAGE")	
		if(state.actInfo.progress==ACT_ORDER||state.actInfo.progress==ACT_P_ORDER){
			state.imgList = [
				"static_niunai/img/b1.jpg?d=20180804",
				"static_niunai/img/b2.jpg?d=20180804",
				"static_niunai/img/b3.jpg?d=20180804",
				"static_niunai/img/b4.jpg?d=20180804",
				"static_niunai/img/b5.jpg?d=20180804",
				"static_niunai/img/b6.jpg?d=20180804",
				"static_niunai/img/b7.jpg?d=20180804"
			]
		}
		else if(state.actInfo.progress==ACT_GO||state.actInfo.progress==ACT_E_GO){
			// 		state.imgList = [
			// 	"bg1",
			// 	"bg2",
			// 	"bg3",
			// 	"bg4",
			// 	"bg5",
			// 	"bg6",
			// 	"bg7",
			// 	"bg8",
			// 	"bg9",
			// ]	
			state.imgList = [
				{url:"static_niunai/img/1.jpg?d=2018080406",class:"bg1"},
				{url:"static_niunai/img/2.jpg?d=2018080406",class:"bg2"},
				{url:"static_niunai/img/3.jpg?d=2018080406",class:"bg3"},
				{url:"static_niunai/img/4.jpg?d=2018080406",class:"bg4"},
				{url:"static_niunai/img/5.jpg?d=2018080406",class:"bg5"},
				{url:"static_niunai/img/6.jpg?d=2018080406",class:"bg6"},
				{url:"static_niunai/img/7.jpg?d=2018080406",class:"bg7"},
				{url:"static_niunai/img/8.jpg?d=2018080406",class:"bg8"},
				{url:"static_niunai/img/9.jpg?d=2018080406",class:"bg9"},
			]
		}
	},		
	//修改用户名
	[RETSET_NAME](state,username) {
		state.userInfo = Object.assign({}, state.userInfo,{username})
	},
	//保存商铺id
	[SAVE_SHOPID](state, shopid) {
		state.shopid = shopid;
	},
	//记录订单页面用户选择的备注, 传递给订单确认页面
	[CONFIRM_REMARK](state, {
		remarkText,
		inputText
	}) {
		state.remarkText = remarkText;
		state.inputText = inputText;
	},
	//是否开发票
	[CONFIRM_INVOICE](state, invoice) {
		state.invoice = invoice;
	},
	//选择搜索的地址
	[CHOOSE_SEARCH_ADDRESS](state, place) {
		state.searchAddress = place;
	},
	//保存geohash
	[SAVE_GEOHASH](state, geohash) {
		state.geohash = geohash;
		
	},
	//确认订单页添加新的的地址
	[CONFIRM_ADDRESS](state, newAddress) {
		state.newAddress.push(newAddress);
	},
	//选择的地址
	[CHOOSE_ADDRESS](state, {
		address,
		index
	}) {
		state.choosedAddress = address;
		state.addressIndex = index;
	},
	//保存下单需要验证的返回值
	[NEED_VALIDATION](state, needValidation) {
		state.needValidation = needValidation;
	},
	//保存下单后购物id 和 sig
	[SAVE_CART_ID_SIG](state, {
		cart_id,
		sig
	}) {
		state.cart_id = cart_id;
		state.sig = sig;
	},
	//保存下单参数，用户验证页面调用
	[SAVE_ORDER_PARAM](state, orderParam) {
		state.orderParam = orderParam;
	},
	//修改下单参数
	[CHANGE_ORDER_PARAM](state, newParam) {
		state.orderParam = Object.assign({}, state.orderParam, newParam);
	},
	//下单成功，保存订单返回信息
	[ORDER_SUCCESS](state, order) {
		state.cartPrice = null;
		state.orderMessage = order;
	},
	//进入订单详情页前保存该订单信息
	[SAVE_ORDER](state, orderDetail) {
		state.orderDetail = orderDetail;
	},
	//退出登录
	[OUT_LOGIN](state) {
		state.userInfo = {};
		state.islogin = false;
	},
	//保存图片
	[SAVE_AVANDER](state, imgPath) {
		state.imgPath = imgPath;
	},
	//删除地址列表
	[SAVE_ADDRESS](state, newAdress) {
		state.removeAddress = newAdress
	},
	//添加地址name
	[SAVE_ADDDETAIL](state, addAddress){
		state.addAddress=addAddress;
	},
	//保存所选问题标题和详情
	[SAVE_QUESTION](state, question) {
		state.question = {...question};
	},
	//增加地址
	[ADD_ADDRESS](state, obj) {
		state.removeAddress = [obj, ...state.removeAddress];
	},
	//会员卡价格纪录
	[BUY_CART](state, price) {
		state.cartPrice = price;
	},

}



// WEBPACK FOOTER //
// ./src/store/mutations.js